import PropTypes from 'prop-types';
import clsx from 'clsx';
import Container from '@/components/Container';
import Link from '@/components/Link';

const defaultProps = {
  categories: [],
  active: null,
};

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  active: PropTypes.string,
};

export default function Categories({
  categories,
  active,
}) {
  return (
    <div className="bg-gray-900 text-gray-100 relative z-20">
      <Container>
        <nav className="w-full flex items-center py-2 space-x-4">
          {categories.map(({ id, slug, name, uri }) => {
            const isActive = active === slug;
            return (
              <Link
                key={id}
                href={uri}
                className={clsx(
                  'font-medium flex items-center transition ease-in-out duration-150',
                  isActive === true && 'pointer-events-none text-green-500',
                  isActive === false && 'border-transparent text-gray-400 hover:text-white',
                )}
              >
                {name}
              </Link>
            );
          })}
        </nav>
      </Container>
    </div>
  );
}

Categories.defaultProps = defaultProps;
Categories.propTypes = propTypes;
